export const SERIES_MARKER_SIZE = 5;

export const ALPHA_CHANNEL_FACTOR = 0.25;

export const AXIS_LABEL_FONT_SIZE = 14;
export const AXIS_TICK_LABEL_FONT_SIZE = 12;
export const AXIS_TICK_SIZE = 6;
export const AXIS_HIGHLIGHTED_TICK_COLOR = 'black';
export const AXIS_UNHIGHLIGHTED_TICK_COLOR = `rgba(0, 0, 0, ${ALPHA_CHANNEL_FACTOR})`;

export const SECTION_RECT_TITLE_FONT_SIZE = 14;

// Use a prefix `ph_` in order to avoid potential conflicts with other search params used by other components.
// For example `tenantId` is used by the placement search.
export const PARAM_FROM = `ph_from`;
export const PARAM_TO = `ph_to`;
export const PARAM_TENANT_ID = `ph_tenantId`;
export const PARAM_SERIES_IDS = `ph_seriesIds`;
